import util from '../util'

let controller = 'ArquivoTransacaoMultiContas'

export default Object.assign({}, util.GetCrud(controller, ['get', 'post']), {
  DadosEnvio: function () {
    return util.Axios.Get(controller + '/DadosEnvio')
  },
  DadosRetorno: function () {
    return util.Axios.Get(controller + '/DadosRetorno')
  },
  InserirArquivo: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  Aprovar: function (codigo) {
    return util.Axios.Post(controller + `/${codigo}/Aprovar`)
  },
  Recusar: function (codigo, dto) {
    return util.Axios.Post(`${controller}/${codigo}/Recusar`, dto)
  },
  Download: function (localArquivo) {
    return util.Axios.Get(controller + `/Download?localArquivo=${localArquivo}`)
  }
})
